export interface RouteConfig {
  path: string;
  label: string;
  icon: string;
  component: string;
}

export const routes: RouteConfig[] = [
  { path: "/", label: "Dashboard", icon: "home", component: "dashboard-page" },
  { path: "/versions", label: "Versions", icon: "smart-compare", component: "versions-page" },
  { path: "/promotions", label: "Releases & Promotions", icon: "file-check", component: "promotions-page" },
  { path: "/bundles", label: "Bundles", icon: "package", component: "deployments-page" },
  { path: "/flagship", label: "Flagship", icon: "flag", component: "flags-page" },
  { path: "/snapshots", label: "Snapshots", icon: "save", component: "snapshots-page" },
  { path: "/presets", label: "Presets", icon: "bookmark", component: "presets-page" },
  { path: "/preview", label: "Preview Builder", icon: "tool", component: "preview-page" },
  { path: "/audit", label: "Audit Log", icon: "history", component: "audit-page" },
];

export function getRouteLabel(path: string): string {
  return routes.find((r) => r.path === path)?.label ?? "";
}
